// extracted by mini-css-extract-plugin
export default {"title_block":"title_title_block__1OgAT"};